import { deliverTicket } from '@jq4race/api-client';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { MY_ACTIVE_KEY } from './use-retrieval-queue';

/**
 * useDeliverTicket — JQ4-26 / US-TICKETS-006
 *
 * Wraps the POST /valet/tickets/:id/deliver call.
 * On success: invalidates MY_ACTIVE_KEY so delivered ticket disappears from list.
 * On 409 error: also invalidates MY_ACTIVE_KEY to remove any stale in_transit entry.
 * No retrieval-queue invalidation needed (delivered tickets were already claimed).
 */
export function useDeliverTicket() {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => deliverTicket(id),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: MY_ACTIVE_KEY });
    },
    onError: (err) => {
      const code = err instanceof Error && 'code' in err ? (err as { code: string }).code : null;
      if (code === 'ticket_already_delivered') {
        void qc.invalidateQueries({ queryKey: MY_ACTIVE_KEY });
      }
      // JQ4-39: payment_required (402) — the caller (HomePage) reads this code and
      // displays the payment message. No optimistic update is applied (REQ-UI-05).
    },
  });
}
